import { render, staticRenderFns } from "./Leads_Root.vue?vue&type=template&id=6449f952&scoped=true&"
import script from "./Leads_Root.vue?vue&type=script&lang=js&"
export * from "./Leads_Root.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6449f952",
  null
  
)

export default component.exports